import React, { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import Footer, { FooterModal } from '@tyc-pc/footer';
import { Cookies } from 'react-cookie';
import Header from '@tyc-pc/header';
import { showLoginModal } from '@tyc-pc/login';
import {
  sensorsInit,
  isNode,
  useUserInfoV2,
  loginConstant,
  loginCookieExpiresOptions,
} from '@tyc-pc/core';
import config from 'utils/config';
import { useSearchParams } from '@component/hooks/search/searchParams';
import InlineScript from '@component/InlineScript';
import reportWebVitals from 'utils/reportWebVitals';

const Sider = dynamic(() => import('@tyc-pc/sider'), {
  ssr: false,
}) as any;
const DynamicFeedbackModal = dynamic(() => import('@tyc-pc/feedback-modal'), {
  ssr: false,
}) as any;
const DynamicBottomBanner = dynamic(() => import('@tyc-pc/bottom-banner'), {
  ssr: false,
}) as any;
const { userInfoName, authTokenName } = loginConstant;

const Layout: FC = (props) => {
  const { queryKey } = useSearchParams();
  /**
   * state 值
   * @state {boolean} feedBackShow          是否显示【反馈】弹窗
   * @state {number} sceneType             【反馈】场景，数据纠错:1  意见反馈:2  我要投诉:3 默认2
   * @state {number} entrance              【反馈】入口，右侧浮窗-反馈: 5 底部导航-投诉: 6
   * @state {boolean} showFooterModal       footer 组件是否显示反馈前【阅读15s】弹窗
   * */
  const [feedBackShow, setFeedBackShow] = useState(false);
  const [entrance, setEntrance] = useState(5);
  const [showFooterModal, setShowFooterModal] = useState(false);
  const [scene, setScene] = useState(2);
  const [phone, setPhone] = useState('');
  const [jwtError, setJwtError] = useState(false);

  const userInfo = useUserInfoV2() as any;

  // 点击 footer 投诉按钮事件
  const onComplaintClick = () => {
    if (userInfo?.data) {
      setPhone(userInfo?.data?.mobile);
      setScene(3);
      setShowFooterModal(true);
    } else {
      showLoginModal();
    }
  };
  // 点击 footer 投诉按钮 15s 阅读后弹出投诉模态框
  const showFeedBack = () => {
    setEntrance(6);
    setShowFooterModal(false);
    setFeedBackShow(true);
  };

  // 处理异地 416 登录问题
  useEffect(() => {
    if (userInfo?.status === 416 || userInfo?.status === 401) {
      setJwtError(true);
      const cookies = new Cookies();
      if (cookies.get(authTokenName)) {
        cookies.remove(userInfoName, loginCookieExpiresOptions);
        cookies.remove(authTokenName, loginCookieExpiresOptions);
      }
    }
  }, [userInfo?.status]);

  useEffect(() => {
    /**
     * 暴露神策等相关属性在 window
     * 初始化神策
     */
    const { sensorsServerUrl, sensorsDebug } = config.sensors;
    window.sensorsServerUrl = sensorsServerUrl;
    window.sensorsDebug = sensorsDebug;
    sensorsInit();

    /**
     * 上报 WebVitals 指标
     */
    reportWebVitals();
  }, []);

  return (
    <>
      <Header showJwtErrorTip={jwtError} searchDefaultValue={queryKey} />

      <div id="page-container">{props.children}</div>

      <DynamicBottomBanner />

      <Sider />

      {!isNode && phone && feedBackShow && (
        <DynamicFeedbackModal
          visible={feedBackShow}
          onClose={() => setFeedBackShow(false)}
          entrance={entrance}
          phoneNum={phone}
          sceneType={scene}
          hideCorrectionScene
        />
      )}

      <Footer onComplaintClick={onComplaintClick} />
      <FooterModal
        phoneNum={userInfo?.mobile || ''}
        visible={showFooterModal}
        onClose={() => setShowFooterModal(false)}
        showFeedBack={showFeedBack}
      />

      <InlineScript id="bd">
        {() => {
          if (process.env.TYC_ENV === 'production' && process.env.NODE_ENV === 'production') {
            // @ts-ignore type any
            // eslint-disable-next-line
            var _hmt = _hmt || [];
            let defId = 'e92c8d65d92d534b0fc290df538b4758';
            if (window.location.hostname && window.location.hostname.indexOf('own.') === 0) {
              defId = '9290806c0c52097851d8d30c7cfa8219';
            }
            const { userAgent } = navigator;
            if (userAgent.indexOf('ignore') < 0) {
              const hm = document.createElement('script');
              hm.src = `//hm.baidu.com/hm.js?${defId}`;
              const s = document.getElementsByTagName('script')[0];
              s.parentNode?.insertBefore(hm, s);
            }
          }
        }}
      </InlineScript>
    </>
  );
};

export default Layout;
